import React, { useState, useEffect, useCallback, useRef } from 'react';
import Modal from "react-bootstrap/Modal";
import ReactToPrint from 'react-to-print';
import ThongKeApi from "service/ThongKe/ThongKeApi";
import { PhieuIn } from './PhieuIn';
import { pushNotification } from 'utils/notifications';
import { formatNumber2 } from '../../../../utils/currencyFormat';
import { getDate } from '../../../../utils/formatDate';
import ReactDropdown from 'react-dropdown';
const ALL_PRINT_TEMPLATES = [
    { Keyword: 'MAUPHIEUCHI', ContractName: 'Phiếu Chi (A4)' },
    { Keyword: 'MAUPHIEUCHIA5', ContractName: 'Phiếu Chi (A5)' }
];
export const ModalIn = ({ show, onHide, thuChiId, type }) => {
    const [detailData, setDetailData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [templates, setTemplates] = useState([]);
    const [selectedTemplate, setSelectedTemplate] = useState('');
    const [htmlToPrint, setHtmlToPrint] = useState('');
    const componentToPrintRef = useRef();

    useEffect(() => {
        if (show) {
            setLoading(true);
            setTemplates(ALL_PRINT_TEMPLATES);
            if (ALL_PRINT_TEMPLATES.length > 0) {
                setSelectedTemplate(ALL_PRINT_TEMPLATES[0].Keyword);
            } else {
                setSelectedTemplate('');
            }
            ThongKeApi.getDetailForChiModal(thuChiId)
                .then(detailRes => {
                    if (detailRes.status === 200 && detailRes.data) {
                        setDetailData(detailRes.data);
                    }
                })
                .catch(() => pushNotification("Lỗi khi tải dữ liệu chi.", "error"))
                .finally(() => setLoading(false));
        }
    }, [show, thuChiId]);
    
    const handleBeforePrint = useCallback(() => {
            return new Promise((resolve) => {
                if (!selectedTemplate) {
                    pushNotification("Vui lòng chọn mẫu in.", "warning");
                    resolve(false);
                    return;
                }
                ThongKeApi.getChiPrintPreview(thuChiId, selectedTemplate)
                    .then(res => {
                        if (res.status === 200 && res.data) {
                            setHtmlToPrint(res.data);
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    })
                    .catch(error => { 
                        console.error("Lỗi khi lấy dữ liệu in:", error);
                        pushNotification("Có lỗi xảy ra khi lấy dữ liệu in.", "error");
                        resolve(false); 
                    });
            });
        }, [thuChiId, selectedTemplate]);
    const renderDetailContent = () => {
        if (loading) return <p>Đang tải chi tiết...</p>;
        if (!detailData) return <p>Không có dữ liệu.</p>;

        const lowerType = type.toLowerCase();
        const commonFieldsChi = (
            <>
                <p><strong>Người nhận:</strong> {detailData[0].NguoiNhan}</p>
                <p><strong>Ngày chi:</strong> {getDate(detailData[0].NgayChi)}</p>
                <p><strong>Mã chứng từ:</strong> {detailData[0].MaChungTu}</p>
                <p><strong>Tổng tiền chi:</strong> {formatNumber2(detailData[0].SoTienThucChi)}</p>
                <p><strong>Người tạo:</strong> {detailData[0].NguoiTao}</p>
                <p><strong>Người chi:</strong> {detailData[0].NguoiChi}</p>
                <p><strong>Ghi chú:</strong> {detailData[0].GhiChu}</p>
            </>
        );

        const contractFieldsChi = (
            <>
                <p><strong>Mã hợp đồng:</strong> {detailData[0].MaHopDong}</p>
                <p><strong>Địa chỉ:</strong> {detailData[0].DiaChi}</p>
                <p><strong>Tiền vay gốc:</strong> {formatNumber2(detailData[0].TienVayGoc)}</p>
            </>
        );

        const feeFieldsChi = (
            <>
                <p><strong>Tiền chi gốc:</strong> {formatNumber2(detailData[0].SoTienChiGoc)}</p>
                <p><strong>Phí kho:</strong> {formatNumber2(detailData[0].PhiKho)}</p>
                <p><strong>Phí khác:</strong> {formatNumber2(detailData[0].PhiKhac)}</p>
            </>
        );

        const hoaHongField = (
            <p><strong>Tiền hoa hồng:</strong> {formatNumber2(detailData[0].SoTienHoaHong)}</p>
        );

        switch (lowerType) {
            case "goc":
            case "lai":
                return <>{commonFieldsChi}{contractFieldsChi}{feeFieldsChi}</>;
            case "ngoaile":
                return commonFieldsChi;
            case "hoahong":
                return <>{commonFieldsChi}{contractFieldsChi}{hoaHongField}</>;
            case "khac":
                return <>{commonFieldsChi}{contractFieldsChi}{feeFieldsChi}{hoaHongField}</>;
            default:
                return <p>Loại chi tiết không xác định.</p>;
        }
    };

    const dropdownOptions = templates.map(t => ({ value: t.Keyword, label: t.ContractName }));

    return (
        <>
            <Modal show={show} onHide={onHide} size="lg" centered className='modal-new modal fade text-left'>
                <Modal.Header>
                    <h4 className="modal-title color7-bold ml-1 mt-1">Chi Tiết Giao Dịch</h4>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <ReactDropdown
                            options={dropdownOptions}
                            onChange={(option) => setSelectedTemplate(option.value)}
                            value={selectedTemplate}
                            placeholder="Chọn mẫu in..."
                            disabled={templates.length === 0}
                            controlClassName="form-control input-sm"
                        />
                        <button
                            type="button"
                            className="close-popup-new mb-1"
                            onClick={onHide}
                        >
                            <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body>{renderDetailContent()}</Modal.Body>
                <Modal.Footer>
                    <ReactToPrint
                        trigger={() => <button className="btn btn-new-main button-popup-submit">In Phiếu</button>}
                        content={() => componentToPrintRef.current}
                        onBeforeGetContent={handleBeforePrint}
                        copyStyles={false}
                    />
                    <button className="btn btn-new-main btn-closenew" onClick={onHide}>Đóng</button>
                </Modal.Footer>
            </Modal>

            <div style={{ display: "none" }}>
                <PhieuIn ref={componentToPrintRef} htmlContent={htmlToPrint} />
            </div>
        </>
    );
};